import { WindowsContainer } from '../../containers/advancedFilters/WindowsContainer';
import { IFilter } from '../../types/advancedFilters';

export const windows: IFilter = {
  component: WindowsContainer,
};
